import {
  ExclamationCircleOutlined,
  SendOutlined,
  TeamOutlined,
  UsergroupDeleteOutlined,
} from '@ant-design/icons';
import { selectRecordsByUiFilterKind } from '@mm/state/selectors/campaignsOverviewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import React from 'react';
import { useSelector } from 'react-redux';
import styles from './AutomationEmailStats.module.css';

export const AutomationEmailStats = ({
  campaignId,
}: {
  campaignId: number;
}) => {
  const automations =
    useSelector((state: StoreState) => state.campaigns.entities) || {};
  const campaign = automations?.find(c => c.id === campaignId);

  if (!campaign) {
    return null;
  }

  const stats = [
    {
      title: 'Queued',
      data: campaign.totalQueuedCount,
      icon: <TeamOutlined className={styles.icon} />,
    },
    {
      title: 'Emails sent',
      data: campaign.totalSendCount,
      icon: <SendOutlined className={styles.icon} />,
    },
    {
      title: 'Suppressed',
      data: campaign.totalSuppressedCount,
      icon: <UsergroupDeleteOutlined className={styles.icon} />,
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.heading}>Automation Statistic</div>
      <div className={styles.statistic}>
        {stats.map(stat => (
          <div className={styles.box} key={stat.title}>
            {stat.icon}
            <div className={styles.stats}>
              <span>{stat.title}</span>
              <span className={styles.data}>
                {(stat.data || 0).toLocaleString()}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
